import { render, staticRenderFns } from "./HealthClinicIcon.vue?vue&type=template&id=318e8141&"
import script from "./HealthClinicIcon.vue?vue&type=script&lang=ts&"
export * from "./HealthClinicIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports